import { render, staticRenderFns } from "./MenuTreeItem.vue?vue&type=template&id=1d60880d"
import script from "./MenuTreeItem.vue?vue&type=script&lang=ts"
export * from "./MenuTreeItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports